let mock = [ {
    id: 1,
    title: "To Kill a Mockingbird",
    author: "Harper Lee",
    year: 1960,
    image: 'harperlee.jpeg',
    },
    {
        id: 2,
        title: "The Great Gatsby",
        author: "F. Scott Fitzgerald",
        image: 'fitgerald.jpeg',
        year: 1925,

    },
    {
        id: 3,
        title: "Pride and Prejudice",
        author: "Jane Austen",
        image: 'janeausten.jpeg',
        year: 1813
    },
    {
        id: 4,
        title: "Crime and Punishment",
        author: "Fyodor Dostoevsky",
        image: 'dostoevsky.jpeg',
        year: 1866
    },
    {
        id: 5,
        title: "The Lion, the Witch, and the Wardrobe",
        author: "C.S. Lewis",
        image: 'cslewis.jpeg',
        year: 1950
    },
    {
        id: 6,
        title: "Frankenstein",
        author: "Mary Shelly",
        image: 'shelly.jpeg',
        year: 1818
    },
    {
        id: 7,
        title: "Dracula",
        author: "Bram Stoker",
        image: 'stoker.jpeg',
        year: 1897
    },
    {
        id: 8,
        title: "The Lord of the Rings",
        author: "J.R.R. Tolkien",
        image: 'tolkien.jpeg',
        year: 1954
    },
    {
        id: 9,
        title: "The Adventures of Huckleberry Finn",
        author: "Mark Twain",
        image: 'twain.jpeg',
        year: 1994
    },
    {
        id: 10,
        title: "Great Expectations",
        author: "Charles Dickens",
        image: 'dickens-expectations.jpeg',
        year: 1861
    },
    {
        id: 11,
        title: "Catch-22",
        author: "Jospeh Heller",
        image: 'heller.jpeg',
        year: 1961
    },
    {
        id: 12,
        title: "Harry Potter and the Sorcerer's Stone",
        author: "J.K. Rowling",
        image: 'rowling.jpeg',
        year: 1997
    },
    {
        id: 13,
        title: "The Catcher in the Rye",
        author: "J.D. Salinger",
        image: 'salinger.jpg',
        year: 1951
    },
    {
        id: 14,
        title: "Alice's Adventures in Wonderland",
        author: "Lewis Carroll",
        image: 'carroll.jpeg',
        year: 1865
    },
    {
        id: 15,
        title: "Les Miserables",
        author: "Victor Hugo",
        image: 'hugo.jpeg',
        year: 1862
    },
    {
        id: 16,
        title: "Charlie and the Chocolate Factory",
        author: "Ronald Dahl",
        image: 'dahl.jpeg',
        year: 1964
    },
    {
        id: 17,
        title: "The Outsiders",
        author: "S.E. Hinton",
        image: 'hinton.jpeg',
        year: 1967
    },
    {
        id: 18,
        title: "The Count of Monte Cristo",
        author: "Alexandre Dumas",
        image: 'dumas.jpeg',
        year: 1844
    },
    {
        id: 19,
        title: "A Tale of Two Citites",
        author: "Charles Dickens",
        image: 'dickens-tale.jpeg',
        year: 1859
    },
    {
        id: 20,
        title: "Wuthering Heights",
        author: "Emily Bronte",
        image: 'bronte.jpeg',
        year: 1847
    },
    {
        id: 21,
        title: "A Christmas Carol",
        author: "Charles Dickens",
        image: 'dickens-carol.jpeg',
        year: 1843
    },
    {
        id: 22,
        title: "Charlotte's Web",
        author: "E.B. White",
        image: 'ebwhite.jpeg',
        year: 1952
    },
    {
        id: 23,
        title: "Anne Frank: The Diary of a Young Girl",
        author: "Anne Frank",
        image: 'annefrank.jpg',
        year: 1947
    },
    {
        id: 24,
        title: "Night",
        author: "Elie Wiesel",
        image: 'wiesel.jpeg',
        year: 1956
    },
    {
        id: 25,
        title: "The Secret Garden",
        author: "Frances Hodgson Burnett",
        image: 'secretgarden.jpeg',
        year: 1911
    },

]

export default mock;
